export const UserManagementConstants = {
  GET_AUTH_LOGIN_REQUEST: 'Auth/GET_AUTH_LOGIN_REQUEST',
  GET_AUTH_LOGIN_SUCCESS: 'Auth/GET_AUTH_LOGIN_SUCCESS',
  GET_AUTH_LOGIN_ERROR: 'Auth/GET_AUTH_LOGIN_ERROR',
  GET_AUTH_LOGOUT: 'Auth/GET_AUTH_LOGOUT',

  GET_AUTH_ACCOUNT_DETAILS_REQUEST: 'Auth/GET_AUTH_ACCOUNT_DETAILS_REQUEST',
  GET_AUTH_ACCOUNT_DETAILS_SUCCESS: 'Auth/GET_AUTH_ACCOUNT_DETAILS_SUCCESS',
  GET_AUTH_ACCOUNT_DETAILS_ERROR: 'Auth/GET_AUTH_ACCOUNT_DETAILS_ERROR',
  GET_SUB_USER_MENU_REQUEST: 'Auth/GET_SUB_USER_MENU_REQUEST',
  GET_SUB_USER_MENU_SUCCESS: 'Auth/GET_SUB_USER_MENU_SUCCESS',
  GET_SUB_USER_MENU_ERROR: 'Auth/GET_SUB_USER_MENU_ERROR',

  SET_LOCALES: 'Auth/SET_LOCALES'
};
